// import React from "react";
import ReactDOM from "react-dom";
// import "./index.less";
// import App from "./App";
import routes from './route'
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(routes , document.getElementById("root"));
serviceWorker.unregister();
